module.exports = __webpack_public_path__ + "img/2B_old.515cf905.jpg";